"use client";
import { motion } from "framer-motion";
import { ArrowRight, Rocket } from "lucide-react";
import ButtonGroup from '@/app/components/ui/ButtonGroup';
import { usePathname } from "next/navigation";
import { getLanguageFromPathname, withLanguagePrefix } from "@/app/lib/i18n-routing";
import { fadeUp } from "@/app/lib/utils/motionVariants";
export default function CTASection( { data }: { data: any }) {
    if (!data) return null;
    const pathname = usePathname();
    const contactPath = withLanguagePrefix(data.button?.url , getLanguageFromPathname(pathname));

    return (
        <section className="py-4 md:py-6 lg:py-8">
            <div className="container mx-auto">
                <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="relative rounded-[32px] overflow-hidden border border-white/10">
                    <div className=" inset-0 bg-gradient-to-br from-primary/20 via-transparent to-secondary/20 z-0" />
                        <div className="absolute inset-0 bg-gradient-to-br from-secondary/20 via-transparent to-primary/20 z-[-1] rounded-[32px] overflow-hidden" />
                    <div className="z-10 p-8 md:p-14 flex flex-col md:flex-row items-center justify-between gap-12">
                        <div className="max-w-2xl flex flex-col gap-6 lg:gap-10 items-start">
                            <div className='flex flex-col'>
                                <h2 className="section-title">{data.title}</h2>
                                <p className=" section-description">{data.subtitle}</p>
                            </div>
                            {data.button?.length > 0 && (
                                <ButtonGroup
                                    buttons={data.button.map((button: any) => ({
                                        title: button.title,
                                        url: withLanguagePrefix(button.url, getLanguageFromPathname(pathname)),
                                        target: button.target || '_self',
                                        variant: button.variant,
                                        content: (<>{button.title} <ArrowRight className="w-5 h-5" /></>),
                                    }))}
                                    containerClass="flex flex-wrap gap-3"
                                    btnClassPrimary="btn-primary"
                                />
                            )}
                        </div>
                        <div className='hidden lg:block relative w-[250px] h-[250px]'>
                            <div className="absolute inset-0 border border-gray-700 rounded-full animate-[spin_20s_linear_infinite]" />
                            <div className="absolute inset-4 border border-indigo-400/30 rounded-full border-dashed animate-[spin_15s_linear_infinite_reverse]" />

                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl shadow-[0_0_40px_rgba(99,102,241,0.4)] rotate-12 flex items-center justify-center">
                                    <Rocket className="w-10 h-10 text-white" />
                                </div>
                            </div>
                        </div>


                    </div>
                </motion.div>
            </div>
        </section>
    );
}
